module.exports = __webpack_public_path__ + "static/media/md-refresh.8cde2f6b.svg";